import React from 'react'
import { Helmet } from 'react-helmet'

const initTea = (isDev: boolean) => `
(function(win) {
  win.collectEvent('init', {
    app_id: 5723,
    channel: 'cn',
    log: ${isDev},
    enable_ab_test: true,
    ab_channel_domain: "https://abtestvm.bytedance.com",
  });
  win.collectEvent('config', {
    _staging_flag: ${isDev ? 1 : 0},
    enable_et_test: ${isDev}
  });
  win.collectEvent('start')
})(window)
`

const teaScript = `
(function(win, export_obj) {
  win['TeaAnalyticsObject'] = export_obj;
  if (!win[export_obj]) {
    function _collect() {
      _collect.q.push(arguments);
    }
    _collect.q = _collect.q || [];
    win[export_obj] = _collect;
  }
  win[export_obj].l = +new Date();
})(window, 'collectEvent');
`

export const getTea = () => {
  const isProd = process.env.NODE_ENV === 'production'

  return (
    <Helmet>
      <script>{teaScript}</script>
      <script
        crossOrigin="anonymous"
        async
        src="https://lf1-cdn-tos.bytescm.com/obj/static/log-sdk/collect/collect.js"
      ></script>
      <script>{initTea(!isProd)}</script>
    </Helmet>
  )
}

export const reportTea = (evt: string, params: any = {}) => {
  if (typeof window === 'undefined') return
  if (window.collectEvent && typeof window.collectEvent === 'function') {
    window.collectEvent(evt, params)
  }
}
